// extracted by mini-css-extract-plugin
export default {"section":"tracker-settings-route_section__c2yb7","content":"tracker-settings-route_content__7NT9t"};